import koko from '../koko'
import app from '../app'
import * as PIXI from 'pixi.js'

const inputCount = {count:0};
export class Input {
	inputID = 0;
	container = null;
	question = null;
	defaultText = "";
	val = "";
	mobileEditCallback = null;
	desktopEditCallback = null;
	desktopEnterPressedCallback = null;
	isSet(){
		return this.val !== this.defaultText;
	}
	displayLength = 50;
	displayExt = "...";
	setDisplayLength(length, ext) {
		this.displayLength = length;
		this.displayExt = ext;
	}
	desktopInput = null;
	desktopOffset = { x:0, y:0 };
	desktopIdleClass = "";
	desktopActiveClass = "";
	setDesktopClasses(defClass, idleClass, activeClass) {
		if(this.desktopInput) this.desktopInput.className += " " + defClass + " " + idleClass;	
		this.desktopIdleClass = idleClass;
		this.desktopActiveClass = activeClass;
	}
    enableValidation = false;
    validationFunc = null;
    validation(func) {
        this.validationFunc = func;
    }
	intervalId = null;
	constructor(container, width, height, xOffset, yOffset){ 
		this.container = container;
		
		var _t = this;
		
		inputCount.count++;
		this.inputID = inputCount.count;
		
		// if(koko.client.system.isMobile) {
			this.hit = new PIXI.Graphics();
			
			this.hit.beginFill('#000000');
			this.hit.alpha = 0;
			this.hit.drawRect(0, 0, width, height);
			this.hit.hitArea = new PIXI.Rectangle(0, 0, width, height);
			// this.hit.buttonMode = true;
			this.hit.position.x = this.container.position.x + xOffset;
			this.hit.position.y = this.container.position.y + yOffset;
			
			this.container.parent.addChild(this.hit);
		// }
		// else
		// {
		if(!koko.client.system.isMobile) {
			// this.container.visible = false;
			
			this.desktopOffset.x = xOffset;
			this.desktopOffset.y = yOffset;
			
			this.desktopInput = document.createElement('input');
			this.desktopInput.className = "DOMscaleable";
			this.desktopInput.style.display = "none";
			//set text
			this.desktopInput.type = "text";
			this.desktopInput.value = this.container.text;
			//dimension
			this.desktopInput.style.width = /*width +*/ "0px";
			this.desktopInput.style.height = /*height +*/ "0px";
			this.desktopInput.style.display = "none";
			
			document.body.appendChild(this.desktopInput);
			
			this.desktopInput.addEventListener('change', function(e){
				if(_t.desktopIdleClass !== "") e.target.className = e.target.className.replace(_t.desktopIdleClass, "");
				if(_t.desktopActiveClass !== "") e.target.className = e.target.className.replace(_t.desktopActiveClass, "");	
				
				if(e.target.value === _t.defaultText) {
					if(_t.desktopIdleClass !== "") {
						e.target.className += " " + _t.desktopIdleClass;
					}
				} else {
					if(_t.desktopActiveClass !== "") {
						e.target.className += " " + _t.desktopActiveClass;
					}
				}
                
                if(_t.enableValidation && _t.validationFunc) _t.validationFunc();

				_t.container.text = e.target.value;
			});
			
			this.desktopInput.addEventListener('focus', function(e){
				if(e.target.value === _t.defaultText) {
					if(_t.desktopIdleClass !== "")e.target.className = e.target.className.replace(_t.desktopIdleClass, "");
					if(_t.desktopActiveClass !== "") e.target.className = e.target.className.replace(_t.desktopActiveClass, "");	
					
					e.target.className += " " + _t.desktopActiveClass;
					
					e.target.value = "";

					_t.container.text = e.target.value + '|';
				}
			});
			
			this.desktopInput.addEventListener('blur', function(e){
				if(e.target.value === "") {
					if(_t.desktopIdleClass !== "")e.target.className = e.target.className.replace(_t.desktopIdleClass, "");
					if(_t.desktopActiveClass !== "") e.target.className = e.target.className.replace(_t.desktopActiveClass, "");	
					
					e.target.className += " " + _t.desktopIdleClass;
					
					e.target.value = _t.defaultText;
				}
				_t.val = e.target.value === _t.defaultText ? "" : e.target.value;
                if(_t.enableValidation && _t.validationFunc) _t.validationFunc();

				_t.container.text = e.target.value;
			});
            
            this.desktopInput.addEventListener('keyup', function(e){
				// console.log('keyup: ', e);
                _t.val = e.target.value === _t.defaultText ? "" : e.target.value;
                if(_t.enableValidation && _t.validationFunc) _t.validationFunc(); 

				_t.container.text = e.target.value + '|'

				if (e.key === 'Enter') {
					if (_t.desktopEnterPressedCallback) {
						_t.desktopEnterPressedCallback();
					}
				}
            });

			this.intervalId = setInterval(this.cursorToEnd, 20);
		}
		
		this.defaultText = container.text;
		
		return this;
	}

	cursorToEnd = () => {
		this.setCursor(this.desktopInput, this.desktopInput.value.length);
	}

	setCursor(node, pos) {
		node = (typeof node == "string" || node instanceof String) ? document.getElementById(node) : node;
	
		if(!node){
			return false;
		}else if(node.createTextRange){
			var textRange = node.createTextRange();
			textRange.collapse(true);
			textRange.moveEnd(pos);
			textRange.moveStart(pos);
			textRange.select();
			return true;
		}else if(node.setSelectionRange){
			node.setSelectionRange(pos,pos);
			return true;
		}
	
		return false;
	}

	idleColor = null;
	activeColor = null;
	setColors(idle, active) {
		this.idleColor = idle;
		this.activeColor = active;
	}
	callback(callback) {
		this.clickCallback = callback;
		return this;	
	}
	enable() {
		var _t = this;
		
		if(koko.client.system.isMobile) {
			//mouse up
			this.hit.interactive = true;
			this.hit.touchstart = this.hit.mousedown = function(e){
				if (_t.mobileEditCallback) {
					_t.mobileEditCallback();
				} else {
					var c = prompt(_t.question || 'Please fill in this field', _t.isSet() ? _t.val : "");
					if(c) {
						_t.val = c;
						
						var dis = c;
						if(c.length > _t.displayLength) dis = c.substr(0, _t.displayLength) + _t.displayExt;
					
						_t.container.text = dis;
					
						if(_t.val === _t.defaultText) {
							if(_t.desktopIdleClass !== null) _t.container.tint = _t.idleColor;
						} else {
							if(_t.desktopActiveClass !== null) _t.container.tint = _t.activeColor;
						}
					}			
				}
				return false;
			}
		}
		else
		{
			//desktop	
			this.desktopInput.style.display = "block";
			this.hit.interactive = true;
			this.hit.touchstart = this.hit.mousedown = (e) => {
				// console.log('Focus on input');
				// console.log(this.desktopInput.focus);
				this.container.text = this.desktopInput.value + '|';
				setTimeout(() => this.desktopInput.focus(), 5);
				if (_t.desktopEditCallback) {
					_t.desktopEditCallback();
				}
			}
			
			app.addResizeListener('input' + this.inputID, function(){
				_t.resize();
			});
		}
		return this;	
	}
	disable(){
		// if(koko.client.system.isMobile) {
			this.hit.interactive = false;
			//remove all event listeners
			var arr = ['touchstart', 'mousedown'];
			for( var i = 0; i < arr.length; i++ ){
				this.hit[arr[i]] = null;	
			}
		// }
		// else
		// {
		if(!koko.client.system.isMobile) {
			//desktop
			this.desktopInput.style.display = "none";
			app.removeResizeListener('input' + this.inputID);
			clearInterval(this.intervalId);
		}
		return this;
	}
    timeoutResize = () => {
        setTimeout(this.resize, 100);
    }
	resize = () => {
		if(!koko.client.system.isMobile) {
			//desktop
			var vp = app.viewPort, left = 0, top = 0;
			
			left = /*typeof this.lastLeft != 'undefined' ? this.lastLeft :*/ vp.x + (this.container.parent.worldTransform.tx + this.container.position.x + this.desktopOffset.x) * vp.s;
			top = /*typeof this.lastTop != 'undefined' ? this.lastTop :*/ vp.y + (this.container.parent.worldTransform.ty + this.container.position.y + this.desktopOffset.y) * vp.s - 30;
			this.lastLeft = left;
			this.lastTop = top;
						
			this.desktopInput.style.left = /*left +*/ "-500px";
			this.desktopInput.style.top = top + "px";
			
			//weird bug when reszieing, the lineheight pushes text to bottom of the textfeidl until you focus (only when vp.s is 1) WEIRD
			this.desktopInput.style.lineHeight = (38*vp.s)+"px";
			this.desktopInput.style[koko.client.cssprops.transform] = "scale("+vp.s+")";
		}
	}
	remove = () => {
		if(!koko.client.system.isMobile) {
			document.body.removeChild(this.desktopInput);
		}
	}
}